import {FreeSpinInfoBox, FreeSpinsInfoView} from '@fantasmagames/slot/src/modules/freespins/info/FreeSpinsInfoView';
import {DeviceType} from '@fantasmagames/core/src/device/DeviceType';
import {Position} from '@fantasmagames/slot/src/modules/reels/ReelConstants';

export class GameFreeSpinsInfoView extends FreeSpinsInfoView {
	protected setupInfoBox(
		title: string,
		layoutName: string,
		numberLayoutName: string,
		textLayoutName: string,
		hudObjectName: string,
	): FreeSpinInfoBox {
		const pos: Position = this.layout.getAbsolutePosition(layoutName);
		// Get the local position in relation to their parent bone (layoutName)
		const textPos: Position = this.layout.getPosition(textLayoutName);
		const numberPos: Position = this.layout.getPosition(numberLayoutName);
		const maxWidth = this.device.type === DeviceType.MOBILE ? 230 : 430;

		const box: FreeSpinInfoBox = new FreeSpinInfoBox(this.resources, 0, title, hudObjectName, -15, maxWidth);
		box.setTextPosition(textPos);
		box.setNumberPosition(numberPos);
		box.position.set(pos.x, pos.y);
		this.container.addChild(box);

		return box;
	}
}



// WEBPACK FOOTER //
// ./src/freespins/info/GameFreeSpinsInfoView.ts